import * as actions from './OTPActions';

const OTPReducers = {
  [actions.OTP_SEND_CODE_SUCCESS]: (state, { payload: { data, headers } }) => {
    return {
      data,
      headers: {
        cParam: headers.cparam,
        expires: headers.expires,
        messageType: headers.messagetype,
      },
    };
  },
  [actions.OTP_VERIFY_CODE_SUCCESS]: (state, { payload }) => {
    state.data = {
      ...state.data,
      code: payload,
    };
    return state;
  },
  [actions.OTP_SET_DATA]: (state, { payload: data }) => {
    return { data };
  },
  [actions.OTP_CLEAR_STATE]: () => {
    return {};
  },
};

export default {
  name: 'OTP',
  reducers: OTPReducers,
};
